/* jshint esversion: 6 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import { useContext, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MyContext } from "../../Context/MyProvider";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { FiCalendar, FiMapPin } from "react-icons/fi";
import { MdOutlineEvent } from "react-icons/md";
import noImage from "../../Images/no_image.png";
import ThemedPageFrame from "./ThemedPageFrame";

const EventCategory = () => {

    const { t } = useTranslation();

    const { BaseUrl } = useContext(MyContext);

    const [eventData, setEventData] = useState([]);
    const [loading, setLoading] = useState(true);

    const navoigate = useNavigate();
    const Location = useLocation();
    const Data = Location.state;

    useEffect(() => {
        const HandleFechData = () => {
            const Userid = localStorage.getItem("Userid") || "0";

            if (!Data?.EventId) {
                setEventData([]);
                setLoading(false);
                return;
            }

            setLoading(true);

            axios.post(`${BaseUrl}user_api/u_cat_event.php`, { uid: Userid, cat_id: Data.EventId })
                .then((res) => {
                    const events = Array.isArray(res?.data?.CatEventData) ? res.data.CatEventData : [];
                    setEventData(events);
                })
                .catch((error) => {
                    console.error("u_cat_event", error);
                    setEventData([]);
                })
                .finally(() => {
                    setLoading(false);
                });
        };

        window.scrollTo(0, 0);
        HandleFechData();
    }, [BaseUrl, Data?.EventId]);

    const handleNavigate = (item) => {
        if (!item) return;

        sessionStorage.setItem("Eventid", item?.event_id || "");
        sessionStorage.setItem("EventSlug", item?.slug || "");

        if (item?.slug) {
            navoigate(`/event-details/${item.slug}`);
        } else {
            navoigate("/event-details");
        }
    };

    const getImageUrl = (image) => {
        if (!image) return noImage;
        if (String(image).startsWith("http") || String(image).startsWith("/")) return image;

        return `${BaseUrl}${image}`;
    };

    const categoryImage = getImageUrl(Data?.CoverImg);
    const categoryTitle = Data?.Title || t("Events");
    const eventCountLabel = `${eventData.length} ${eventData.length === 1 ? "Event" : "Events"}`;

    const summary = useMemo(() => (
        <>
            <span>{t("Events")}</span>
            <strong>{loading ? "--" : eventData.length}</strong>
        </>
    ), [eventData.length, loading, t]);

    const renderSkeleton = () => (
        <div className="events_page_grid">
            {[1, 2, 3, 4, 5, 6].map((item) => (
                <div key={item} className="events_page_card events_page_card_skeleton">
                    <span></span>
                    <div></div>
                    <p></p>
                    <small></small>
                </div>
            ))}
        </div>
    );

    return (
        <ThemedPageFrame
            activePath="/events"
            eyebrow="Event Category"
            title={categoryTitle}
            subtitle="Browse events from this collection with quick access to dates, venues, and booking details."
            summary={summary}
            className="events_page_layout event_category_page_layout"
        >
            <div className="event_category_page_shell">
                <section className="event_category_cover">
                    <img
                        src={categoryImage}
                        alt={categoryTitle}
                        onError={(e) => {
                            e.currentTarget.onerror = null;
                            e.currentTarget.src = noImage;
                        }}
                    />
                    <div>
                        <span>{t("Category")}</span>
                        <strong>{categoryTitle}</strong>
                        <p>{loading ? t("Loading events...") : eventCountLabel}</p>
                    </div>
                </section>

                <section className="events_page_section">
                    <div className="events_page_section_head">
                        <div>
                            <h2>{categoryTitle}</h2>
                            <p>{t("Select an event to view full details and booking options.")}</p>
                        </div>
                        <span>{loading ? t("Loading") : eventCountLabel}</span>
                    </div>

                    {loading ? (
                        renderSkeleton()
                    ) : eventData.length === 0 ? (
                        <div className="events_page_empty">
                            <MdOutlineEvent />
                            <h2>{t("Event Not Available !!")}</h2>
                            <p>{t("Please check back later.")}</p>
                        </div>
                    ) : (
                        <div className="events_page_grid">
                            {eventData.map((item, index) => (
                                <button
                                    key={item?.event_id || item?.slug || index}
                                    type="button"
                                    onClick={() => handleNavigate(item)}
                                    className="events_page_card"
                                >
                                    <span className="events_page_badge">{t("Event")}</span>
                                    <img
                                        src={getImageUrl(item?.event_img)}
                                        alt={item?.event_title || "Event"}
                                        onError={(e) => {
                                            e.currentTarget.onerror = null;
                                            e.currentTarget.src = noImage;
                                        }}
                                    />
                                    <div className="events_page_card_body">
                                        <strong>{item?.event_title || t("Nabhiverse Event")}</strong>
                                        <p><FiMapPin /> {item?.event_place_name || t("Nabhiverse")}</p>
                                        <small><FiCalendar /> {item?.event_sdate || t("Date announced soon")}</small>
                                    </div>
                                </button>
                            ))}
                        </div>
                    )}
                </section>
            </div>

        </ThemedPageFrame>
    )
}

export default EventCategory
/* jshint ignore:end */
